import { DecimalPipe } from "@angular/common";


export let  roundToXDecimals = (num: number, decimals: number,locale ="en")=> {
let decimalPipe = new DecimalPipe(locale)
  const formattedNumber = decimalPipe.transform(num, `1.${decimals}-${decimals}`);
  return formattedNumber;
}
